module.exports = __webpack_public_path__ + "static/media/peter-libby.1c0b76eb.jpg";